export default (props, e) => {
	dataLayer.push({
		'event': 'fgWebAnalytics',
		'fgVarCat': 'Interakce se stránkou',
		'fgVarAct': props.actionVarAct,
		'fgVarLbl': props.actionVarLbl,
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/pushFgWebAnalytics.js